import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import { Navigate, useParams } from "react-router-dom";
import { useQuery } from "react-query";
import userServices from "../../services/users";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import Table from "../../components/Table";
import DButton from "../../components/DButton";
import moment from "moment";

const columns = [
  {
    Header: "معرف العملية",
    accessor: "id",
  },

  {
    Header: "الرصيد قبل",
    accessor: "balance_before",
  },
  {
    Header: "الرصيد بعد",
    accessor: "balance_after",
  },

  {
    Header: "تاريخ العملية",
    accessor: "created_at",
  },
  {
    Header: "العملية",
    accessor: "action",
  },
];
const Transactions = ({ title }) => {
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(0);
  const { data, isLoading, error } = useQuery(
    ["getAllTransactions", id, currentPage],
    () => userServices.getUserTransaction(id, currentPage + 1)
  );
  const formattedData = (data) => {
    console.log(data);
    if (data.length > 0) {
      return data.map((d) => ({
        ...d,
        action: d.balance_before > d.balance_after ? "سحب" : "شحن",
        created_at: moment(d.created_at).format("hh:mm:ss YYYY-MM-DD"),
        balance_after: +d.balance_after.toFixed(6),
        balance_before: +d.balance_before.toFixed(6),
      }));
    }

    return [];
  };
  const actionSorrundWithButton = (cell) => {
    return (
      <DButton
        className={"text-white min-w-[100px] rounded-[50px_!important]"}
        bgColor={cell.value === "شحن" ? "success" : "danger"}
      >
        {cell.render("Cell")}
      </DButton>
    );
  };
  if (error) return <Navigate to="/404" />;
  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <DCard className={`relative ${isLoading ? "min-h-[400px]" : ""}`}>
        {isLoading ? (
          <DSpinner />
        ) : (
          <Table
            currentPage={currentPage}
            totalData={error ? 0 : data.data.data.total}
            head={columns}
            body={error ? [] : formattedData(data.data.data.data)}
            setCurrentPage={setCurrentPage}
            elements={{
              action: actionSorrundWithButton,
            }}
          />
        )}
      </DCard>
    </div>
  );
};

export default Transactions;
